<template>
  <div class="cart__items">
    <transition-group name="fade" tag="div">
      <div class="cart__item" v-for="item in cartItems" :key="item.id">
        <div class="cart__item-image">
          <img :src="item.image.url" />
        </div>
        <div class="cart__item-data">
          <div>
            <h3 class="cart__item-heading">
              {{ item.title }}
            </h3>
            <div class="cart__item-description">
              {{ item.subHeading }}
            </div>
            <div class="cart__item-variation">
              {{ translations.variant }}: {{ item.variantTitle }}
            </div>
            <!-- <div class="cart__item-storage">In stock</div> -->
          </div>
          <div
            v-if="item.comment && !item.editComment"
            class="cart__item-comment"
          >
            <div class="headline">
              Comment
              <div class="edit" @click="item.editComment = true">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.1129 2.10246L10.4309 0.419456C10.2176 0.215542 9.93394 0.101739 9.63888 0.101739C9.34382 0.101739 9.06013 0.215542 8.84688 0.419456L1.31088 8.03046C1.2774 8.06416 1.25298 8.10579 1.23988 8.15146L0.11688 12.0775C0.103235 12.1256 0.102682 12.1765 0.115276 12.2249C0.127871 12.2733 0.153157 12.3174 0.188525 12.3528C0.223893 12.3882 0.26806 12.4135 0.316465 12.4261C0.364871 12.4387 0.41576 12.4381 0.46388 12.4245L4.38888 11.2985C4.43455 11.2854 4.47617 11.2609 4.50988 11.2275L12.1099 3.68446C12.3194 3.47351 12.437 3.18827 12.437 2.89096C12.437 2.59364 12.3194 2.3084 12.1099 2.09746L12.1129 2.10246ZM2.45888 8.51146L2.94188 9.47646C2.9691 9.53101 3.01332 9.57524 3.06788 9.60246L4.03288 10.0855V10.8195L2.69188 11.2025L1.33788 9.84846L1.72088 8.50746L2.45888 8.51146ZM4.43988 9.66246L3.66588 9.27546L9.05588 3.88546L10.0879 4.91946L4.59688 10.3595V9.91246C4.59611 9.8599 4.58062 9.80861 4.55216 9.76442C4.5237 9.72022 4.48341 9.6849 4.43588 9.66246H4.43988ZM3.26988 8.87946L2.88288 8.10546C2.85952 8.05889 2.82368 8.01974 2.77936 7.99237C2.73503 7.965 2.68397 7.95049 2.63188 7.95046H2.18288L7.62488 2.45946L8.65688 3.49146L3.26988 8.87946ZM1.16288 10.4695L2.07588 11.3825L0.797881 11.7475L1.16288 10.4695ZM11.7169 3.29946L10.4799 4.52446L8.01688 2.06046L9.24088 0.824456C9.34767 0.722433 9.48969 0.665503 9.63738 0.665503C9.78507 0.665503 9.92708 0.722433 10.0339 0.824456L11.7159 2.50646C11.8202 2.61186 11.8787 2.75417 11.8787 2.90246C11.8787 3.05075 11.8202 3.19305 11.7159 3.29846L11.7169 3.29946Z"
                    fill="#919191"
                  />
                  <path
                    d="M0.38588 12.5405C0.326195 12.5406 0.267295 12.5269 0.213833 12.5003C0.16037 12.4738 0.11381 12.4352 0.0778284 12.3876C0.0418466 12.3399 0.0174286 12.2846 0.00650402 12.2259C-0.00442053 12.1672 -0.00155291 12.1068 0.0148801 12.0495L1.14188 8.12546C1.16068 8.06257 1.19508 8.00547 1.24188 7.95946L8.77788 0.349456C9.01063 0.125258 9.32121 0 9.64438 0C9.96755 0 10.2781 0.125258 10.5109 0.349456L12.0419 1.88546V1.87946L12.1849 2.02346C12.4132 2.25445 12.5413 2.56616 12.5413 2.89096C12.5413 3.21576 12.4132 3.52746 12.1849 3.75846L4.58188 11.3025C4.53618 11.3492 4.47942 11.3835 4.41688 11.4025L0.49188 12.5255C0.457418 12.5354 0.42174 12.5404 0.38588 12.5405ZM9.64188 0.203456C9.37296 0.203592 9.11455 0.307888 8.92088 0.494456L1.38688 8.10346C1.36573 8.12461 1.35026 8.15075 1.34188 8.17946L0.22088 12.1075C0.208237 12.1523 0.213873 12.2003 0.236552 12.241C0.259232 12.2816 0.297106 12.3117 0.34188 12.3245C0.374495 12.3342 0.409265 12.3342 0.44188 12.3245L4.36688 11.1985C4.39551 11.1904 4.42165 11.1753 4.44288 11.1545L12.0419 3.61046C12.2216 3.42723 12.3259 3.18322 12.3342 2.92672C12.3426 2.67023 12.2543 2.41996 12.0869 2.22546L12.0419 2.17646L10.3569 0.492456C10.1647 0.307611 9.90854 0.204083 9.64188 0.203456ZM0.64188 11.9005L1.10788 10.2705L2.27288 11.4345L0.64188 11.9005ZM1.21088 10.6695L0.94588 11.5955L1.87188 11.3305L1.21088 10.6695ZM2.65688 11.3215L1.21588 9.88046L1.63788 8.40446H2.51988L3.03188 9.42746C3.04905 9.46159 3.07675 9.48928 3.11088 9.50646L4.13388 10.0185V10.8985L2.65688 11.3215ZM1.45088 9.82146L2.71788 11.0885L3.92388 10.7445V10.1515L3.01588 9.69746C2.94155 9.6601 2.88124 9.59979 2.84388 9.52546L2.38988 8.61746H1.78988L1.45088 9.82146ZM4.48788 10.6125V9.91246C4.48725 9.87975 4.47758 9.84786 4.45993 9.82033C4.44227 9.79279 4.41734 9.77068 4.38788 9.75646L3.48788 9.30546L9.05488 3.73846L10.2349 4.91846L4.48788 10.6125ZM4.48188 9.57246C4.54552 9.60414 4.59923 9.65271 4.63714 9.71284C4.67506 9.77298 4.69572 9.84237 4.69688 9.91346V10.1135L9.94188 4.91746L9.05788 4.03346L3.84188 9.24646L4.48588 9.56846L4.48188 9.57246ZM3.24188 9.05646L2.78988 8.15646C2.7757 8.12655 2.75332 8.10128 2.72536 8.08358C2.69739 8.06588 2.66498 8.05648 2.63188 8.05646H1.93188L7.62488 2.31246L8.80488 3.49246L3.24188 9.05646ZM2.43488 7.84646H2.63488C2.70656 7.84612 2.77689 7.8659 2.83788 7.90356C2.89887 7.94121 2.94807 7.99523 2.97988 8.05946L3.30188 8.70346L8.51288 3.49146L7.62888 2.60746L2.43488 7.84646ZM10.4809 4.67346L7.86888 2.06046L9.16888 0.750456C9.29507 0.628739 9.46356 0.560723 9.63888 0.560723C9.8142 0.560723 9.98269 0.628739 10.1089 0.750456L11.7929 2.43446C11.8898 2.53302 11.954 2.65912 11.9765 2.79551C11.9991 2.9319 11.9789 3.07194 11.9189 3.19646H11.9729L11.7929 3.37546L10.4809 4.67346ZM8.16388 2.06046L10.4809 4.37746L11.6419 3.22546C11.7265 3.13942 11.7739 3.02361 11.7739 2.90296C11.7739 2.78231 11.7265 2.66649 11.6419 2.58046L9.95988 0.898456C9.87278 0.815144 9.75691 0.768645 9.63638 0.768645C9.51585 0.768645 9.39998 0.815144 9.31288 0.898456L8.16388 2.06046Z"
                    fill="#919191"
                  />
                </svg>
                Edit
              </div>
              <div class="delete" @click="deleteComment(item)">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.2935 21.2454C20.169 21.2456 20.0457 21.2211 19.9308 21.1734C19.8158 21.1256 19.7114 21.0557 19.6235 20.9674L0.277523 1.62143C0.189537 1.53344 0.119746 1.42899 0.0721283 1.31403C0.0245108 1.19907 0 1.07586 0 0.951431C0 0.827001 0.0245108 0.703788 0.0721283 0.588829C0.119746 0.47387 0.189537 0.369415 0.277523 0.281429C0.365509 0.193444 0.469964 0.123652 0.584923 0.0760345C0.699882 0.0284171 0.823095 0.00390625 0.947525 0.00390625C1.07196 0.00390625 1.19516 0.0284171 1.31012 0.0760345C1.42508 0.123652 1.52954 0.193444 1.61752 0.281429L20.9635 19.6274C21.0956 19.7601 21.1855 19.9288 21.2218 20.1125C21.2582 20.2961 21.2393 20.4864 21.1676 20.6593C21.096 20.8323 20.9747 20.9801 20.8192 21.0842C20.6636 21.1884 20.4807 21.2441 20.2935 21.2444V21.2454Z"
                    fill="#E2E2E2"
                  />
                  <path
                    d="M0.947308 21.2455C0.760115 21.2452 0.577207 21.1895 0.421647 21.0853C0.266087 20.9812 0.144838 20.8333 0.0731819 20.6604C0.00152621 20.4875 -0.0173285 20.2972 0.018998 20.1136C0.0553244 19.9299 0.145204 19.7612 0.277306 19.6285L19.6233 0.277523C19.801 0.099828 20.042 0 20.2933 0C20.5446 0 20.7856 0.099828 20.9633 0.277523C21.141 0.455218 21.2408 0.696222 21.2408 0.947521C21.2408 1.19882 21.141 1.43983 20.9633 1.61752L1.61731 20.9675C1.52948 21.0557 1.42506 21.1257 1.31007 21.1734C1.19509 21.2212 1.0718 21.2457 0.947308 21.2455V21.2455Z"
                    fill="#E2E2E2"
                  />
                </svg>
                Delete
              </div>
            </div>
            <div class="text">
              {{ item.comment }}
            </div>
          </div>
          <div v-if="item.editComment" class="cart__item-comment">
            <div>
              <textarea v-model="item.comment"></textarea>
            </div>
          </div>
          <div class="cart__item-actions">
            <div
              class="action"
              @click="item.editComment = true"
              v-if="!item.editComment && !item.comment"
            >
              <CommentIcon />

              {{ translations.comment }}
            </div>

            <div
              class="action action--save"
              @click="saveComment(item)"
              v-if="item.editComment"
            >
              <SaveIcon />

              Save comment
            </div>

            <div
              class="action"
              v-if="!isDeleting(item.id)"
              @click="removeItem(item.id)"
            >
              <TrashIcon /> {{ translations.remove }}
            </div>
            <slot name="inlineloader" v-if="isDeleting(item.id)"></slot>
          </div>
          <div class="cart__item-spinner--mobile">
            <qty-spinner
              :min="1"
              :value="item.qty"
              :step="1"
              :small="true"
              v-model="item.qty"
            ></qty-spinner>
          </div>
        </div>
        <div class="cart__item-spinner">
          <qty-spinner
            :min="1"
            :value="item.qty"
            :step="1"
            :small="true"
            v-model="item.qty"
          ></qty-spinner>
        </div>
      </div>
    </transition-group>
    <transition name="fade">
      <div class="l-cart__loader" v-if="loading">
        <slot name="loader" v-if="!success"></slot>
        <slot name="success" v-if="success"></slot>
      </div>
    </transition>
    <transition name="fade">
      <div class="l-cart__loader-bg" v-if="loading"></div>
    </transition>
  </div>
</template>

<script>
import QtySpinner from "./QtySpinner.vue";
import axios from "axios";
import CommentIcon from "-!vue-svg-loader!../../images/comment.svg";
import TrashIcon from "-!vue-svg-loader!../../images/trash.svg";
import EditIcon from "-!vue-svg-loader!../../images/edit.svg";
import SaveIcon from "-!vue-svg-loader!../../images/save.svg";
import CloseIcon from "-!vue-svg-loader!../../images/close.svg";

export default {
  name: "cart",
  components: {
    QtySpinner,
    CommentIcon,
    TrashIcon,
    EditIcon,
    SaveIcon,
    CloseIcon,
  },
  data() {
    return {
      loading: false,
      success: false,
      deleting: false,
      itemDeleting: [],
      cartItems: this.items,
    };
  },
  props: {
    items: Array,
    csrf: String,
    translations: Object,
  },
  computed: {},
  watch: {},
  methods: {
    removeItem: function (itemId) {
      if (this.deleting) {
        return;
      }

      this.deleting = true;
      this.itemDeleting = itemId;

      const formData = new FormData();

      formData.append(`lineItems[${itemId}][remove]`, 1);

      this.request(formData)
        .then((data) => {
          if (data.success) {
            let itemToRemove = this.cartItems.find((item) => {
              return item.id === itemId;
            });

            let itemIndex = this.cartItems.indexOf(itemToRemove);
            this.cartItems.splice(itemIndex, 1);
            this.deleting = false;
            this.$store.commit("setCart", data.cart);
          }
        })
        .catch((err) => (this.deleting = false));
    },
    saveComment: function (item) {
      item.editComment = false;
      this.updateCart();
    },
    deleteComment: function (item) {
      item.editComment = false;
      item.comment = "";
      this.updateCart();
    },
    updateCart: function () {
      this.loading = true;
      this.false = true;
      const formData = new FormData();
      this.cartItems.forEach((item) => {
        formData.append(`lineItems[${item.id}][qty]`, item.qty);

        if (item.comment) {
          formData.append(
            `lineItems[${item.id}][options][comment]`,
            item.comment
          );
        } else {
          formData.append(`lineItems[${item.id}][options]`, []);
        }
      });

      this.request(formData)
        .then((data) => {
          if (data.success) {
            this.$store.commit("setCart", data.cart);
            this.success = true;
            setTimeout(() => {
              this.loading = false;
              this.success = false;
            }, 1800);
          }
        })
        .catch((err) => (this.deleting = false));
    },

    request: async function (formData) {
      let response = "";
      formData.append("action", "quantity-extensions/cart/update-cart");
      formData.append("CRAFT_CSRF_TOKEN", this.csrf);

      const promise = axios.post(document.location.href, formData);

      const dataPromise = promise.then((response) => response.data);
      return dataPromise;
    },
    isDeleting: function (itemId) {
      if (!this.deleting) {
        return false;
      }

      if (itemId == this.itemDeleting) {
        return true;
      }

      return false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "~sass-nitty/nitty";
@import "../../scss/base/variables.scss";

.cart {
  &__item {
    display: flex;
    padding: 22px 0;
    border-bottom: 1px solid #a8a8a8;

    &-spinner {
      &--mobile {
        display: none;
      }
    }

    &:last-child {
      border-bottom: none;
    }

    &-comment {
      margin-top: 22px;
      margin-bottom: -15px;
      display: flex;
      flex-direction: column;

      textarea {
        padding: 12px;
        width: 100%;
        max-width: 370px;
        height: 80px;
        resize: none;
        border: 1px solid #b9b9b9;
        font-size: 14px;
        line-height: 24px;
      }

      .headline,
      .text {
        font-size: 14px;
        line-height: 24px;
      }

      .headline {
        display: flex;
        align-items: center;
        font-weight: 500;
      }

      .delete,
      .edit {
        color: #919191;
        font-weight: 400;
        transition: all $t-hover;
        display: flex;
        align-items: center;

        svg {
          height: 12px;
          width: auto;
          margin-right: 6px;
          path {
            transition: all $t-hover;
            fill: #919191;
          }
        }

        &:hover {
          cursor: pointer;
          color: $brand-orange;
          svg {
            path {
              fill: $brand-orange;
            }
          }
        }
      }

      .delete {
        margin-left: 12px;
      }

      .edit {
        margin-left: 8px;
      }
    }

    &-image {
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: baseline;
      min-width: 152px;
      padding: 5px 16px;
      line-height: 0;
      background: $brand-light-grey;
    }

    &-data {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      padding-left: 20px;
      padding-right: 45px;
    }

    &-heading {
      margin-bottom: 5px;
      font-size: 18px;
      line-height: 24px;
      font-weight: 700;
    }

    &-description,
    &-variation {
      font-size: 14px;
      line-height: 24px;
    }

    &-storage {
      font-size: 12px;
      line-height: 18px;
    }

    &-actions {
      display: flex;
      align-items: center;
      margin-top: 20px;
      font-size: 14px;
      line-height: 30px;
      color: $brand-grey;

      .action {
        display: flex;
        align-items: center;
        margin-right: 18px;
        transition: all 0.3s $t-nice;
        svg {
          margin-right: 8px;
          path {
            transition: all 0.3 $t-nice;
          }
        }

        &:hover {
          cursor: pointer;
          color: $brand-orange;
          svg path {
            fill: $brand-orange;
          }
        }

        &--save {
          padding: 0px 7px;
          color: #fff;
          background: $brand-orange;
          svg {
            path {
              fill: #fff;
            }
          }

          &:hover {
            color: #fff;
            background: #ca6400;
            svg {
              path {
                fill: #fff;
              }
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 700px) {
  .cart__item {
    &-spinner {
      display: none;
      &--mobile {
        margin-top: 10px;
        display: flex;
      }
    }
  }
}

@media all and (max-width: 540px) {
  .cart__item {
    &-actions {
      align-items: flex-start;
      flex-direction: column;
    }
  }
}

@media all and (max-width: 400px) {
  .cart__item {
    &-image {
      min-width: 100px;
    }
  }
}

@media all and (max-width: 350px) {
  .cart__item {
    flex-direction: column;

    &-image {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    &-data {
      padding-left: 0;
      padding-right: 0;
      margin-top: 10px;
    }
  }
}
</style>
